<template>
  <div v-if="shopname" class="not-model">
    <span class="shop-name body-m-regular">{{ shopname }}</span>
    <div v-if="rating" class="social-share">
      <div class="shop-rating body-m-regular">
        <span>
          <span>{{ rating }}</span>
        </span>
      </div>
      <div v-if="isProved" class="shop__proved" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import type { ModelOfferItem } from '~/interfaces/api';

export default defineComponent({
  name: 'ShopRating',
  props: {
    shop: {
      type: Object as () => ModelOfferItem,
      default: () => {},
    },
    align: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const isProved = computed(() => {
      return props.shop?.shop_info?.proved_merchant || null;
    });
    const rating = computed(() => {
      if (Number(props.shop?.shop_info?.merchant_rating) === 0) return null;
      return props.shop?.shop_info?.merchant_rating?.toFixed(1) || null;
    });
    const shopname = computed(() => {
      return props.shop?.shop_info?.name || null;
    });
    const mediaStore = useMediaQueryStore();
    const isTablet = computed(() => mediaStore.isTablet);
    return {
      rating,
      isTablet,
      shopname,
      isProved,
    };
  },
});
</script>

<style scoped lang="scss">
.not-model {
  grid-column: 1/5;
  gap: 4px;
  justify-content: center;
  margin-top: 8px !important;
  display: flex;

  .shop__proved {
    height: 14px;
    width: 14px;
    margin-right: 8px;
    background: url('/static/images/icon/proved.svg') center / cover no-repeat;
    @include lg-block {
      height: 16px;
      width: 16px;
    }
  }

  .social-share {
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;

    .shop-rating {
      position: relative;
      padding-left: 17px;

      &:after {
        background-image: url('/static/images/icon/star-rating.svg');
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        width: 13px;
        height: 12px;
        background-position: center center;
        background-size: 100%;
        background-repeat: no-repeat;
        display: block;
      }

      @include lg-block {
        padding-left: 19px;
        &:after {
          width: 15px;
          height: 14px;
        }
      }
    }
  }

  .shop-name {
    padding-left: 18px;
    display: inline-block;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 1px;
      width: 14px;
      height: 14px;
      background-image: url('/static/images/icon/shop-b.svg');
      background-position: center center;
      background-size: auto;
      background-repeat: no-repeat;
    }

    @include lg-block {
      &:after {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
